import * as React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { Button, Card, Stack, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { CreateQuestionDialog } from "../components/CreateQuestionDialog";
import { FruitifyQuestionSearch } from "../components/FruitifyQuestionSearch";
import { withPageTracking } from "../../../services/postHog";

const QuestionsOverview = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [createdQuestion, setCreatedQuestion] = useState(null);

  return (
    <FruitifyContainer>
      <CreateQuestionDialog
        open={open}
        setOpen={setOpen}
        forYearGroup={createdQuestion?.yearGroup}
        forSubject={createdQuestion?.subject}
        forEducationLevel={createdQuestion?.educationLevel}
        createdQuestion={createdQuestion}
        setCreatedQuestion={setCreatedQuestion}
        onComplete={(question) => navigate(`/questions/view/${question.id}`)}
      />
      <Card mb={2}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={2}
        >
          <Typography variant="h3" fontWeight="bold">
            Fruitify Question Hub
          </Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => navigate("/questions/create")}
          >
            Create Question
          </Button>
        </Stack>
        <FruitifyQuestionSearch
          hideTitle
          onQuestionSelected={(question) => {
            setOpen(true);
            setCreatedQuestion(question);
          }}
        />
      </Card>
    </FruitifyContainer>
  );
};

export default withPageTracking(QuestionsOverview, {
  feature: "questions-overview",
});
